<template>
    <ZhaiHeadPC class="zhai-head"></ZhaiHeadPC>

    <div class="container phome-container-box errong" v-if="getUser">
        <ZhaiJiuGongPC menu="1"></ZhaiJiuGongPC>

        <!-- 红条：放在九宫格下方，会员中心内容上方，靠左 -->
        <div class="mt-2 diff-banner-wrap">
            <VipUpgradeDiffBanner
                    ref="vipDiffBanner"
                    :user-id="getUser && getUser.id"
                    @select="handleSelectPermanentUpgrade"
            />
        </div>

        <!-- 会员中心主要信息显示部分 -->
        <div class="container-fluid mt-2 shengse">
            <div class="row">
                <!-- 左侧 -->
                <div class="col-6 kale">
                    <div class="LeftPart">
                        <div class="mx-2">
                            <div class="row mt-2 hua">
                                <div class="dixian px-3 py-2 mb-1 d-flex justify-content-between">
                                    <div class="py-1">
                                        <span>欢迎登录：</span>&nbsp;{{ getUser.username }}
                                    </div>
                                </div>
                            </div>

                            <div class="row py-2 hui">
                                <div class="px-3 Profile d-flex align-items-center justify-content-start">
                                    <div class="La">会员等级：</div>
                                    <span class="niandu changlv">
                                        <strong>
                                            <template v-if="getUser.level_expire_date && new Date() > new Date(getUser.level_expire_date)">
                                                （VIP已过期）
                                            </template>
                                            <template v-else>
                                                {{ getUser.level }}
                                            </template>
                                        </strong>
                                    </span>
                                </div>
                            </div>

                            <div class="row py-2 hui">
                                <div class="px-3 Profile d-flex align-items-center justify-content-start">
                                    <div class="La">VIP有效期：</div>
                                    <div class="niandu">
                                        <span>{{ formatExpireDate(getUser.level_expire_date) }}</span>
                                    </div>
                                </div>
                            </div>

                            <div class="hui py-2" v-if="!fetchFailed && userEvents.length > 0">
                                <div>
                                    <div class="La px-1">支付订单：</div>
                                    <table class="layui-table">
                                        <colgroup>
                                            <col width="150">
                                            <col width="150">
                                            <col width="200">
                                            <col>
                                        </colgroup>
                                        <thead>
                                        <tr>
                                            <th>订单类型</th>
                                            <th>支付金额</th>
                                            <th>支付时间</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(event, index) in userEvents" :key="index">
                                            <td>{{ event.event }}</td>
                                            <td>{{ event.price }}元</td>
                                            <td>{{ formatDate(event.create_time) }}</td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 右侧 -->
                <div class="col-6">
                    <div class="RightPart">
                        <div class="pt-2">
                            <table class="table table-bordered" style="margin-top:10px;">
                                <thead>
                                <tr>
                                    <th scope="col">类型</th>
                                    <th scope="col">价格</th>
                                    <th scope="col">查看权限</th>
                                    <th scope="col">有效期</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr>
                                    <td>VIP月度会员</td>
                                    <td>¥100</td>
                                    <td>楼凤</td>
                                    <td>+1月度</td>
                                </tr>
                                <tr>
                                    <td>VIP季度会员</td>
                                    <td>¥160</td>
                                    <td>楼凤+暗巷</td>
                                    <td>+1季度</td>
                                </tr>
                                <tr>
                                    <td>VIP年度会员</td>
                                    <td>¥300</td>
                                    <td>楼凤+暗巷</td>
                                    <td>+1年</td>
                                </tr>
                                <tr>
                                    <td>VIP永久会员</td>
                                    <td>¥500</td>
                                    <td>所有内容</td>
                                    <td>永久</td>
                                </tr>
                                </tbody>
                            </table>

                            <div class="text-center my-3">
                                <router-link to="/upgradeVIP" class="btn btn-primary">购买VIP</router-link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 会员中心主要信息显示部分结束 -->
    </div>

    <div class="gongxi2"></div>

    <ZhaiFootPC></ZhaiFootPC>

    <!-- 升级支付 模态框 -->
    <div class="modal fade" id="upgradeModal" tabindex="-1" aria-labelledby="upgradeModalLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="upgradeModalLabel">升级支付</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>

                <div class="modal-body">
                    <div id="step1">
                        <div>
                            升级VIP目前仅支持支付宝，请确认升级的VIP类型及支付金额是否正确，点击“支付”进行支付。
                        </div>
                        <div class="mt-2">
                            <strong>升级类型：</strong>
                            <span id="uplevel">{{ modalData.type }}</span>
                        </div>
                        <div class="mt-2">
                            <strong>支付金额：</strong>
                            <span id="payamount">{{ modalData.amount }}元</span>
                        </div>
                        <div class="mt-2">
                            <strong>支付方式：</strong>
                            <label class="pay-option1">
                                <input type="radio" name="paytype" value="2040" v-model="payType" id="alipay">
                                {{ alipayOptionText }}
                            </label>
                        </div>

                        <div class="mt-2" style="color:red;">
                            如果支付加载不出来，多试几次就成功了。
                        </div>

                        <div class="text-center mt-5">
                            <button id="startPayBtn" class="btn btn-success" @click="startPayment">支付</button>
                            <button class="btn btn-success" data-bs-dismiss="modal">关闭</button>
                        </div>
                    </div>

                    <div id="step2" style="display:none;">
                        <div id="paymsg" style="text-align: center;font-size: 1rem;font-weight: bold;"></div>
                        <p id="code_msg" style="text-align: center;background: #040404;color: #ffeb00;font-size: 1rem;">
                            如页面出现支付步骤文字说明，请务必看完（尤其是付款注意事项）再进行支付。
                        </p>
                        <p style="text-align: center;font-size: 1rem;color: #000;">
                            请确认支付完成后，再点击“支付完成”
                        </p>
                        <div class="text-center">
                            <button id="btnpaysucess" class="btn btn-primary mr-5" @click="onManualCheckPayment">支付完成</button>
                            <button class="btn btn-primary mr-5" data-bs-dismiss="modal">关闭</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 成功模态框 -->
    <div class="modal fade" id="successModal" tabindex="-1" aria-labelledby="successModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 200px;">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-smile" style="font-size: 2rem; color: #00c26f;"></i>
                    <p class="mb-0 ms-2" id="successMessage" style="font-size: 1rem; color: #00c26f;"></p>
                </div>
            </div>
        </div>
    </div>

    <!-- 失败模态框 -->
    <div class="modal fade" id="generalErrorModal" tabindex="-1" aria-labelledby="errorModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-shake" style="max-width: 350px;">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-emoji-frown" style="font-size: 2rem; color: #dc3545;"></i>
                    <p class="mb-0 ms-2" id="errorMessage" style="font-size: 1rem; color: #dc3545;"></p>
                </div>
            </div>
        </div>
    </div>

    <!-- 时间限制提示模态框 -->
    <div class="modal fade" id="timeRestrictionModal" tabindex="-1" aria-labelledby="timeRestrictionModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered" style="max-width: 350px;">
            <div class="modal-content">
                <div class="modal-body d-flex align-items-center justify-content-center">
                    <i class="bi bi-clock" style="font-size: 2rem; color: red;"></i>
                    <p class="mb-0 ms-2" id="timeRestrictionMessage" style="font-size: 1rem; color: red;"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import ZhaiJiuGongPC from "../componentspc/ZhaiJiuGongPC";
    import VipUpgradeDiffBanner from "../components/VipUpgradeDiffBanner.vue";
    import { mapGetters } from "vuex";
    import http from "../utils/http.js";
    import { Modal } from "bootstrap";
    import QRCode from "qrcodejs2";

    export default {
        name: "PMemberCenter",
        components: {
            ZhaiHeadPC,
            ZhaiFootPC,
            ZhaiJiuGongPC,
            VipUpgradeDiffBanner
        },

        data() {
            return {
                userEvents: [],
                fetchFailed: false,

                modalData: { type: "", amount: 0 },
                payType: "2040",
                orderId: null,
                manualPolling: false
            };
        },

        computed: {
            ...mapGetters(["getUser", "isLoggedIn"]),
            alipayOptionText() {
                return "支付宝";
            }
        },

        methods: {
            // 红条点击：直接弹支付框
            handleSelectPermanentUpgrade(payload) {
                this.modalData.type = payload.type;
                this.modalData.amount = payload.amount;
                this.openModal();
            },

            fetchUserEventInfo() {
                if (!this.getUser || !this.getUser.id) {
                    console.error("用户未登录");
                    return;
                }

                const userId = this.getUser.id;
                const url = `/platform/frontEnd/getUserEventInfo?userid=${userId}`;

                http.get(url)
                    .then(response => {
                        if (response.data && response.data.status === 1) {
                            this.userEvents = response.data.data;
                            this.fetchFailed = false;
                        } else {
                            this.fetchFailed = true;
                            console.error("获取用户支付记录失败:", response.data.msg);
                        }
                    })
                    .catch(error => {
                        this.fetchFailed = true;
                        console.error("API 请求错误:", error);
                    });
            },

            formatDate(date) {
                if (!date) return "";
                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const day = String(d.getDate()).padStart(2, "0");
                const hours = String(d.getHours()).padStart(2, "0");
                const minutes = String(d.getMinutes()).padStart(2, "0");
                const seconds = String(d.getSeconds()).padStart(2, "0");
                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            },

            formatExpireDate(date) {
                if (!date) {
                    return "无";
                }

                const now = new Date();
                const expireDate = new Date(date);

                if (now > expireDate) {
                    return "无";
                }

                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, "0");
                const day = String(d.getDate()).padStart(2, "0");
                const hours = String(d.getHours()).padStart(2, "0");
                const minutes = String(d.getMinutes()).padStart(2, "0");
                const seconds = String(d.getSeconds()).padStart(2, "0");

                return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
            },

            showTimeRestrictionModal(message) {
                document.getElementById("timeRestrictionMessage").innerText = message;
                const timeModal = new Modal(document.getElementById("timeRestrictionModal"));
                timeModal.show();

                setTimeout(() => {
                    timeModal.hide();
                }, 5000);
            },

            openModal() {
                document.getElementById("step1").style.display = "block";
                document.getElementById("step2").style.display = "none";

                const paymsg = document.getElementById("paymsg");
                if (paymsg) {
                    paymsg.innerHTML = "";
                }

                const modalElement = document.getElementById("upgradeModal");
                const modalInstance = new Modal(modalElement);
                modalInstance.show();
            },

            resetPayButton() {
                const payButton = document.getElementById("startPayBtn");
                if (payButton) {
                    payButton.textContent = "支付";
                    payButton.disabled = false;
                }
            },

            startPayment() {
                const payButton = document.getElementById("startPayBtn");
                if (payButton) {
                    payButton.textContent = "生成中";
                    payButton.disabled = true;
                }

                const { id: userid, username, email } = this.getUser || {};
                if (!userid || !username || !email) {
                    this.resetPayButton();
                    alert("用户信息不完整，请重新登录！");
                    return;
                }

                let requestUrl = "";

                if (this.modalData.type === "限时补差价升级永久会员") {
                    requestUrl = `/platform/frontEndPayment/requestPermanentUpgrade?userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
                } else {
                    requestUrl = `/platform/frontEndPayment/request?name=${encodeURIComponent(this.modalData.type)}&money=${this.modalData.amount}&userid=${userid}&username=${encodeURIComponent(username)}&email=${encodeURIComponent(email)}&paytype=${this.payType}`;
                }

                http.get(requestUrl)
                    .then(response => {
                        const res = response.data;

                        if (res && res.status === 1 && res.data) {
                            const { payUrl, mchOrderNo } = res.data;

                            if (!payUrl) {
                                this.resetPayButton();
                                this.showFailureModal("支付链接为空，请联系管理员！");
                                return;
                            }

                            this.orderId = mchOrderNo;
                            this.generateQRCode(payUrl);
                        } else {
                            this.resetPayButton();
                            const errorMessage = res?.msg || "未知错误";
                            this.showFailureModal(`支付请求失败：${errorMessage}`);
                        }
                    })
                    .catch(error => {
                        this.resetPayButton();
                        this.showFailureModal(`请求支付失败，请重试。错误详情: ${error.message}`);
                    });
            },

            generateQRCode(payUrl) {
                document.getElementById("paymsg").innerHTML = "请用手机相机扫描下方二维码，从浏览器打开，将自动跳转支付。";

                const qrCodeContainer = document.createElement("div");
                qrCodeContainer.id = "qrcode";
                qrCodeContainer.style.width = "200px";
                qrCodeContainer.style.height = "200px";
                qrCodeContainer.style.marginTop = "20px";

                document.getElementById("paymsg").appendChild(qrCodeContainer);

                new QRCode(qrCodeContainer, {
                    text: payUrl,
                    width: 200,
                    height: 200,
                    colorDark: "#000000",
                    colorLight: "#ffffff",
                    correctLevel: QRCode.CorrectLevel.H
                });

                document.getElementById("step1").style.display = "none";
                document.getElementById("step2").style.display = "block";

                let remainingTime = 300;

                const countdown = document.createElement("p");
                countdown.id = "countdown";
                countdown.style.textAlign = "center";
                countdown.style.marginTop = "10px";
                countdown.style.fontWeight = "normal";
                countdown.style.color = "rgba(255, 127, 127)";
                countdown.style.fontSize = "0.9rem";
                document.getElementById("paymsg").appendChild(countdown);

                const timer = setInterval(() => {
                    if (remainingTime <= 0) {
                        clearInterval(timer);
                        countdown.innerHTML = "支付已超时，请关闭重新选择支付！";
                        qrCodeContainer.style.filter = "blur(5px)";
                        this.resetPayButton();
                    } else {
                        const minutes = Math.floor(remainingTime / 60);
                        const seconds = remainingTime % 60;
                        countdown.innerHTML = `请在 ${minutes}:${seconds < 10 ? "0" + seconds : seconds} 内完成支付`;
                        remainingTime--;
                    }
                }, 1000);
            },

            onManualCheckPayment() {
                this.manualPolling = true;
                this.checkPaymentStatus();
            },

            checkPaymentStatus() {
                if (!this.orderId) return;

                const statusUrl = `/platform/frontEndPayment/checkPaymentStatus?outTradeNo=${this.orderId}`;
                fetch(statusUrl)
                    .then(response => response.json())
                    .then(data => {
                        if (data.status === 1) {
                            this.handlePaymentSuccessStatus();
                        } else if (this.manualPolling) {
                            this.showFailureModal("未检测到支付完成，请稍后重试");
                        }
                    })
                    .catch(error => {
                        console.error("轮询支付状态异常:", error);
                    });
            },

            handlePaymentSuccessStatus() {
                this.$store.dispatch("checkLoginStatus");
                this.fetchUserEventInfo();

                if (this.$refs.vipDiffBanner) {
                    this.$refs.vipDiffBanner.refresh();
                }

                this.showSuccessModal("支付已成功");
            },

            showSuccessModal(message) {
                document.getElementById("successMessage").innerText = message;
                const successModal = new Modal(document.getElementById("successModal"));
                successModal.show();

                setTimeout(() => {
                    successModal.hide();
                    document.body.classList.remove("modal-open");
                    const backdrop = document.querySelector(".modal-backdrop");
                    if (backdrop) {
                        backdrop.remove();
                    }
                    window.location.reload();
                }, 2000);
            },

            showFailureModal(message) {
                document.getElementById("errorMessage").innerText = message;
                const errorModal = new Modal(document.getElementById("generalErrorModal"));
                errorModal.show();

                setTimeout(() => {
                    errorModal.hide();
                }, 3000);
            }
        },

        watch: {
            isLoggedIn(val) {
                if (!val) {
                    this.$router.push("/login");
                }
            }
        },

        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) {
                next("/login");
            } else {
                next();
            }
        },

        created() {
            this.fetchUserEventInfo();
        }
    };
</script>

<style scoped>
    body {
        font-family: Arial, sans-serif;
    }

    .gongxi2 {
        height: 20px;
    }

    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    .diff-banner-wrap {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .new-container-padding {
        padding-right: calc(var(--bs-gutter-x) * 0.5) !important;
        padding-left: calc(var(--bs-gutter-x) * 0.5) !important;
    }

    .layui-table {
        width: 100%;
        background-color: #fff;
        color: #666;
        margin: 10px 0;
        border: 1px solid #ddd;
        border-collapse: collapse;
    }

    .layui-table th,
    .layui-table td {
        border: 1px solid #ddd;
        text-align: center;
        vertical-align: middle;
        line-height: 2rem;
    }

    .layui-table th {
        font-weight: normal;
        background-color: #f2f2f2;
    }

    .btn-primary {
        color: #fff;
        background-color: #00c26f;
        margin-bottom: 1rem !important;
        margin-top: 1rem !important;
        border: none !important;
        font-size: 1rem;
    }

    .table td,
    .table th {
        text-align: center;
        vertical-align: middle;
    }

    .table th {
        background-color: #d5d5d5;
    }

    .kale {
        border-right: 1px solid #f2f2f2;
    }

    @media (min-width: 768px) {
        .zhai-head {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }

        .errong {
            margin-top: 90px;
        }
    }

    .hua {
        font-size: 1rem;
    }

    .hui {
        font-size: 0.9rem;
    }

    #paymsg {
        color: #00c26f;
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    #qrcode {
        margin-top: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: filter 0.5s ease;
    }

    #countdown {
        font-size: 0.7rem;
        color: red !important;
        text-align: center;
    }

    .pay-option1 {
        margin-right: 40px;
    }
</style>
